import { fetcher } from "../fetcher";

const BASE = "/client-projects";

export const projectService = {
  getProject: async (params?: object) => {
    return await fetcher(`${BASE}`, {
      method: "GET",
      params,
      schema: projecstSchema,
    });
  },
};
